import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getApiUrl, apiList } from 'src/app/core/Constants/apiList';

@Injectable({
  providedIn: 'root'
})
export class CustomValidationService {

  constructor(
    private http: HttpClient,
  ) { }

  public getCustomValidationList(payload:any) {
    let endpoint = getApiUrl(apiList.customValidation.getCustomValidationList,payload);
    return this.http.get<any>(endpoint)
  }
  public setValidationStatus(id: number) {
    let endpoint = getApiUrl(apiList.customValidation.setValidationStatus) +`/${id}`;
    return this.http.put<any>(endpoint,null)
  }

}
